import { Flame, Instagram, Facebook, Music2 } from "lucide-react";

const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/noxway888", icon: Instagram, testId: "social-instagram" },
  { label: "Facebook", href: "https://www.facebook.com/NOXWAY", icon: Facebook, testId: "social-facebook" },
  { label: "TikTok", href: "https://www.tiktok.com/@noxway888", icon: Music2, testId: "social-tiktok" },
];

export default function Footer() {
  return (
    <footer className="border-t border-stone-200 py-10 bg-white" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-2.5">
          <span className="w-7 h-7 rounded-md bg-[#f97316] flex items-center justify-center">
            <Flame size={14} className="text-white" strokeWidth={2.4} />
          </span>
          <span className="font-display font-bold tracking-[0.15em] text-xs text-[#17150f]">
            NOXWAY<span className="align-super text-[8px] text-[#f97316]">™</span>
          </span>
        </div>
        <p className="text-xs text-stone-400 text-center">
          Wildfire protection technology — © 2026 NOXWAY™
        </p>
        <div className="flex items-center gap-5">
          {SOCIALS.map((s) => {
            const Icon = s.icon;
            return (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                aria-label={`NOXWAY on ${s.label}`}
                data-testid={s.testId}
                className="w-9 h-9 rounded-md border border-stone-200 flex items-center justify-center text-stone-500 hover:text-[#f97316] hover:border-[#f97316] transition-colors"
              >
                <Icon size={16} />
              </a>
            );
          })}
          <a href="/blog" data-testid="footer-blog-link" className="text-xs font-medium text-stone-500 hover:text-[#f97316] transition-colors">Journal</a>
          <a href="/community" data-testid="footer-community-link" className="text-xs font-medium text-stone-500 hover:text-[#f97316] transition-colors">Community</a>
          <a href="mailto:sales@noxway.shop" data-testid="footer-email-link" className="text-xs font-medium text-stone-500 hover:text-[#f97316] transition-colors">sales@noxway.shop</a>
        </div>
      </div>
    </footer>
  );
}
